export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			value: '',
		},
	],
	singular_model_name_spanish: 'Tipo de metodo de pago',
	plural_model_name_spanish: 'Tipos de metodo de pago',
	create_model_name_spanish: 'Nuevo',
	text_delete: 'el',
}